import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import('./Router'),
  loading: () => null,
})
